import { render, staticRenderFns } from "./return_goods_confirm.vue?vue&type=template&id=12a28967&scoped=true&"
import script from "./return_goods_confirm.vue?vue&type=script&lang=js&"
export * from "./return_goods_confirm.vue?vue&type=script&lang=js&"
import style0 from "./return_goods_confirm.vue?vue&type=style&index=0&id=12a28967&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a28967",
  null
  
)

export default component.exports